import { render, staticRenderFns } from "./Karin-details.vue?vue&type=template&id=2bc9999c"
import script from "./Karin-details.vue?vue&type=script&lang=js"
export * from "./Karin-details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports